import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/wonder/Header";
import { Hero } from "@/components/wonder/Hero";
import { PricingBand } from "@/components/wonder/PricingBand";
import { StepsFlow } from "@/components/wonder/StepsFlow";
import { DualAudience } from "@/components/wonder/DualAudience";
import { ProductDefinition } from "@/components/wonder/ProductDefinition";
import { OutcomeTabs } from "@/components/wonder/OutcomeTabs";
import { EffortCard } from "@/components/wonder/EffortCard";
import { FaqSection } from "@/components/wonder/FaqSection";
import { ClosingCta } from "@/components/wonder/ClosingCta";
import { Footer } from "@/components/wonder/Footer";

const Home = () => (
  <div className="min-h-screen bg-[#0b100d] text-[#edf2f4] antialiased selection:bg-[#ff8a4c]/30 selection:text-[#f3f5f3]">
    <Header />
    <main id="main-content">
      <Hero />
      <PricingBand />
      <StepsFlow />
      <DualAudience />
      <ProductDefinition />
      <OutcomeTabs />
      <EffortCard />
      <FaqSection />
      <ClosingCta />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
